<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6" lg="3">
        <b-card class="text-white bg-primary">
          <div class="h4 m-0">{{ account_day.montant_operation_entre }}</div>
          <div>Nombre d'entreés : {{ account_day.nb_operation_entre }}</div>
          <b-progress height={} class="progress-white progress-xs my-3" :value="100"/>
          <small class="text-muted">Opérations entrées</small>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card class="text-white bg-warning">
          <div class="h4 m-0">{{ account_day.montant_sorti }}</div>
          <div>Nombre de sorties : {{ account_day.nb_sorti }}</div>
          <b-progress height={} class="progress-white progress-xs my-3" :value="100"/>
          <small class="text-muted">Opérations sorties</small>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3" v-if="can('chart_commission')">
        <b-card class="text-white bg-danger">
          <div class="h4 m-0">{{ account_day.commission_totale }}</div>
          <div>Nombre total d'entrées : {{ account_day.nb_total_entre }}</div>
          <b-progress height={} class="progress-white progress-xs my-3" :value="100"/>
          <small class="text-muted">Commissions</small>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3" v-if="can('chart_marge')">
        <b-card class="text-white bg-info" style="background:rgb(119, 120, 121) !important; border-color:#FFF !important;">
          <div class="h4 m-0">{{ account_day.marge }}</div>
          <div>Nombre total d'entrées : {{ account_day.nb_total_entre }}</div>
          <b-progress height={} class="progress-white progress-xs my-3" :value="100"/>
          <small class="text-muted">Marges</small>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card class="text-white bg-success" v-if="can('soldecaisse')">
          <div class="h4 m-0">{{ account_day.soldecaisse }}</div>
          <div>Nombre total entrées/sorties : {{ account_day.nb_total_entree_sortie }}</div>
          <b-progress height={} class="progress-white progress-xs my-3" :value="100"/>
          <small class="text-muted">Solde de caisse</small>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12" v-if="bool_commissions">
        <b-card header="Commissions des 7 derniers jours" v-if="can('chart_commission')">
          <div class="col-lg-12" >
              <apexchart width="100%" height="400" type="bar" :options="OptionsCommissions" :series="seriesCommissions"></apexchart>
          </div>
        </b-card>
      </b-col>
      <b-col sm="12" md="12" v-if="bool_commissions">
        <b-card header="Marges des 7 derniers jours" v-if="can('chart_marge')">
          <div class="col-lg-12" >
              <apexchart width="100%" height="400" type="bar" :options="OptionsCommissions" :series="seriesMarges"></apexchart>
          </div>
        </b-card>
      </b-col>
      <!-- <b-col sm="12" md="6" v-if="bool_account">
        <b-card header="Montants entrés">
          <apexchart width="100%" height="350" type="pie"  :options="chartOptions_account_entree" :series="series_account_entree" />
        </b-card>
      </b-col>
      <b-col sm="12" md="6" v-if="bool_account">
        <b-card header="Montants sorties">
          <apexchart width="100%" height="350" type="pie"  :options="chartOptions_account_sorti" :series="series_account_sorti" />
        </b-card>
      </b-col> -->
      <b-col sm="12" md="12" v-if="bool_account">
        <b-card header="Montants sorties">
          <div id="chart">
            <apexchart type=line height=350 :options="chartOptions" :series="series" />
          </div>
        </b-card>
      </b-col>
    </b-row>
</div>
 
</template>
<script>


import SocialBoxChartExample from './dashboard/SocialBoxChartExample'
import { Callout } from '@coreui/vue'

export default {
  name: 'dashboard',
  
  components: {
    SocialBoxChartExample,
    Callout,
    //apexchartM: VueApexCharts,

  },
  data: function () {
    return {
      bool_commissions:false,
      bool_account:false,
      OptionsCommissions: {
        chart: {
          id: 'Commissions'
        },
        xaxis: {
          categories: []
        }
      },
      seriesCommissions: [{
        name: 'Montants',
        data: []
      }],
      OptionsMarges: {
        chart: {
          id: 'Marges'
        },
        xaxis: {
          categories: []
        }
      },
      seriesMarges: [{
        name: 'Montants',
        data: []
      }],

      series_account_entree: [],
      chartOptions_account_entree: {
        labels: [],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }] 
      },
      account_day :{},
      series_account_sorti: [],
      chartOptions_account_sorti: {
        labels: [],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }] 
      },


        series: [
          {
            name: "Montants - entrés",
            data: []
          },
          {
            name: "Montants - sortis",
            data: []
          }
        ],
        chartOptions: {
          chart: {
            shadow: {
              enabled: true,
              color: '#000',
              top: 18,
              left: 7,
              blur: 10,
              opacity: 1
            },
            toolbar: {
              show: false
            }
          },
          colors: ['#77B6EA', '#545454'],
          dataLabels: {
            enabled: true,
          },
          stroke: {
            curve: 'smooth'
          },
          title: {
            text: 'Comparaison des montants entrés / sortis',
            align: 'left'
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          markers: {      
            size: 6
          },
          xaxis: {
            categories: [],
            title: {
              text: '7 derniers jours'
            }
          },
          yaxis: {
            title: {
              text: 'Montants entrés / sortis'
            },
            min: 0,
            max: 0
          },
          legend: {
            position: 'top',
            horizontalAlign: 'right',
            floating: true,
            offsetY: -25,
            offsetX: -5
          }
        },
      

      reload_option:false,
     
    }
  },
  methods: {
    can(perm){
        return this.$store.getters['auth/can'](perm)
    },
    async reloader(){
      console.log('params reloaders ',this.$route.params.reload_option)
      if (this.$route.params.reload_option==true || this.$route.params.reload_option=='true'){
        this.$router.push({
            name: 'Dashboard', 
            params: { reload_option: false }
        });
        console.log('test reloarders')
        await location.reload();
        
      }
    },
    async get_all_account(){
      this.OptionsCommissions.xaxis.categories = []
      await this.$store.dispatch('charts/get_all_account').then((response)=>{
        this.data_charts_account =  store.getters['charts/rows'];
      })
      console.log('données à mettre ',this.data_charts_account[7].solde[0])
      //this.account_day = this.data_charts_account[7].solde[0]
      this.account_day.montant_operation_entre = parseInt(this.data_charts_account[7].solde[0].montant_total_entre.replace(/ /g, '')).toLocaleString("fr-FR", {style: "currency", currency: "XOF"});
      this.account_day.montant_sorti = parseInt(this.data_charts_account[7].solde[0].montant_sorti.replace(/ /g, '')).toLocaleString("fr-FR", {style: "currency", currency: "XOF"});
      this.account_day.nb_operation_entre = parseInt(this.data_charts_account[7].solde[0].nb_total_entre.replace(/ /g, ''));
      this.account_day.nb_sorti =parseInt(this.data_charts_account[7].solde[0].nb_sorti.replace(/ /g, ''));
      this.account_day.nb_total_entre =parseInt(this.data_charts_account[7].solde[0].nb_total_entre.replace(/ /g, ''));
      this.account_day.commission_totale = parseInt(this.data_charts_account[7].solde[0].commission_totale.replace(/ /g, '')).toLocaleString("fr-FR", {style: "currency", currency: "XOF"});
      this.account_day.soldecaisse = parseInt(this.data_charts_account[7].solde[0].soldecaisse.replace(/ /g, '')).toLocaleString("fr-FR", {style: "currency", currency: "XOF"});
      this.account_day.marge = parseInt(this.data_charts_account[7].solde[0].marge.replace(/ /g, '')).toLocaleString("fr-FR", {style: "currency", currency: "XOF"});
      this.account_day.nb_total_entree_sortie = this.data_charts_account[7].solde[0].nb_sorti+this.account_day.nb_total_entre
      console.log("account day ",this.account_day)
      this.data_charts_account.forEach(element => {
        this.OptionsCommissions.xaxis.categories.push(element.date)
        this.chartOptions_account_entree.labels.push(element.date)
        this.chartOptions_account_sorti.labels.push(element.date)
        this.chartOptions.xaxis.categories.push(element.date)
        // let account = parseInt(element.solde[0].commission_totale)
        let commission_totale = element.solde[0].commission_totale.replace(/ /g, ''); 
        let marges = element.solde[0].marge.replace(/ /g, ''); 
        let montant_total_entre = element.solde[0].montant_total_entre.replace(/ /g, ''); 
        let montant_sorti = element.solde[0].montant_sorti.replace(/ /g, ''); 
        this.seriesCommissions[0].data.push(parseInt(commission_totale))
        this.seriesMarges[0].data.push(parseInt(marges))
        this.series_account_entree.push(parseInt(montant_total_entre))
        //this.series_account_entree.push(parseInt(montant_total_entre))
        
        this.series_account_sorti.push(parseInt(montant_sorti))
        this.series[0].data.push(parseInt(montant_total_entre))
        this.series[1].data.push(parseInt(montant_sorti))
        this.bool_commissions = true
        this.bool_account = true
        // console.log(this.chartOptions.xaxis)
      });
        console.log("fff ",this.OptionsCommissions) 
        let max_entree = Math.max.apply(null, this.series_account_entree)
        let min_entree =Math.min.apply(null, this.series_account_entree)
        let max_sorti = Math.max.apply(null, this.series_account_sorti)
        let min_sorti =Math.min.apply(null, this.series_account_sorti)
        if (max_sorti>=max_entree){
          this.chartOptions.yaxis.max = max_sorti
        }else{this.chartOptions.yaxis.max=max_entree}
    }

  },
  created () {
    this.reloader()
  },
  async mounted(){
    await this.get_all_account()
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
